module.exports = __webpack_public_path__ + "static/media/corkease-4.7ad0e69a.jpg";